import { Component, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { PartnerComponentBase } from './partner-search-details.base';
import { PartnerContactComponent } from './partner-contact.component';

@Component({
    templateUrl: './partner-search-details-contacts.component.html',
    selector: 'ep-partner-details-contacts',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PartnerContactComponent]
})
export class PartnerSearchDetailsContactsComponent extends PartnerComponentBase {
    public selectedPartnerId: number;
    private partnerContactComponent = viewChild(PartnerContactComponent);

    async partnerSet(): Promise<void> {
        if (this.selectedPartnerId === this.selectedPartner?.PartnersId) {
            await this.partnerContactComponent().refresh();
        }
        else {
            this.selectedPartnerId = this.selectedPartner?.PartnersId ?? 0;
        }
    }
}
